import { LicenseConfirmationMinimalFlowModalProps } from '../../types/components/license-profile/LicenseConfirmationMinimalFlowModal';

import { Dialog } from '@headlessui/react';
import { ExitIcon } from '../../modules/Icons';
import LicenseConfirmationMinimalFlow from '../license-confirmation-minimal-flow/LicenseConfirmationMinimalFlow';

const LicenseConfirmationMinimalFlowModal: React.FC<LicenseConfirmationMinimalFlowModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const close = () => setIsOpen(false);

  return (
    <Dialog open={isOpen} onClose={close} className="relative z-[99]">
      <div className="fixed inset-0 bg-black/80" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center text-center">
          <Dialog.Panel className="w-full max-w-[860px] transform overflow-hidden rounded-[10px] px-5 lg:px-[48px] pt-[36px] pb-[50px] text-left align-middle shadow-xl transition-all bg-[#252A2D]">
            <div className="eurostile text-[18px] md:text-[24px] lg:text-[32px] font-medium leading-6 !text-white uppercase">
              Confirm License
            </div>
            <ExitIcon
              className="absolute top-6 right-6 w-6 h-6 text-gray-500 cursor-pointer"
              onClick={close}
            />
            <LicenseConfirmationMinimalFlow onFlowCompleted={close} />
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  )
};

export default LicenseConfirmationMinimalFlowModal;
